// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2JIOa","row":"ProcedureTreatmentSummary_row__2KhE7"};